import { getStore } from "@/utils/storage";


export default {
    SET_LOGGED(state, { userInfo }) {
        state.userInfo = userInfo;
    },


    SET_LOGOUT(state) {
        state.userInfo = null;
    },

    initUser(state) {
        const userInfo = getStore('userInfo', true);
        if (userInfo) {
            state.userInfo = userInfo
        }
    }
};


// WEBPACK FOOTER //
// ./src/store/mutations.js